export const getColumnWidth = (isFirstColumn: boolean, width?: number | string) => {
  if (isFirstColumn) return '200px'

  return width ? `${width}px` : '150px'
}
